import React from "react";
import "./loading.css";

const Loading1 = () => {
  return (
    <div className="load-wrapp">
      <div className="load-1">
        <p>Please wait human </p>
        <div className="line"></div>
        <div className="line"></div>
        <div className="line"></div>
      </div>
    </div>
  );
};

export default Loading1;
